'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
/* injects from baggage-loader */

/* eslint no-console: 0 */

exports.default = getProject;

var _reduxSaga = require('redux-saga');

var _kebakaran = require('kebakaran');

var _pureGraph = require('pure-graph');

var _firebase = require('../utils/firebase');

var _firebase2 = _interopRequireDefault(_firebase);

var _projectsActions = require('../actions/projectsActions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = [getProject].map(regeneratorRuntime.mark);

function getProject(projectId) {
  var projectStream, project, _sagaCbLoose,

  // check for projects/` existence
  listener, callback, projectsRef, projectsData;

  return regeneratorRuntime.wrap(function getProject$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          if (projectId) {
            _context.next = 2;
            break;
          }

          return _context.abrupt('return');

        case 2:
          projectStream = (0, _kebakaran.stream)((0, _kebakaran.struct)({
            name: (0, _firebase2.default)('projects/' + projectId + '/name'),
            graph: (0, _firebase2.default)('projects/' + projectId + '/graph'),
            nodesData: (0, _firebase2.default)('projects/' + projectId + '/nodesData'),
            public: (0, _firebase2.default)('projects/' + projectId + '/public'),
            owner: (0, _firebase2.default)('projects/' + projectId + '/owner')
          }));
          _context.prev = 3;

        case 4:
          if (!true) {
            _context.next = 24;
            break;
          }

          _context.next = 7;
          return projectStream.next();

        case 7:
          project = _context.sent;
          _sagaCbLoose = (0, _kebakaran.sagaCbLoose)();
          listener = _sagaCbLoose.listener;
          callback = _sagaCbLoose.callback;
          projectsRef = (0, _firebase2.default)('projects/');

          projectsRef.once('value', listener);
          _context.next = 15;
          return (0, _reduxSaga.cps)(callback);

        case 15:
          projectsData = _context.sent;


          if (!projectsData) {
            (0, _firebase2.default)('projects/').set(true);
          }

          if (project) {
            _context.next = 20;
            break;
          }

          _context.next = 20;
          return (0, _reduxSaga.put)((0, _projectsActions.setProject)({}));

        case 20:
          _context.next = 22;
          return (0, _reduxSaga.put)((0, _projectsActions.setProject)(_extends({}, project, {
            id: projectId,
            graph: (0, _pureGraph.convertFromIncidentForm)(project.graph) || _pureGraph.EMPTY_GRAPH
          })));

        case 22:
          _context.next = 4;
          break;

        case 24:
          _context.next = 29;
          break;

        case 26:
          _context.prev = 26;
          _context.t0 = _context['catch'](3);

          if (!(_context.t0 instanceof _reduxSaga.SagaCancellationException)) {
            console.warn('unknown Error', _context.t0);
          }

        case 29:
          _context.prev = 29;

          projectStream.close();
          return _context.finish(29);

        case 32:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked[0], this, [[3, 26, 29, 32]]);
}


//////////////////
// WEBPACK FOOTER
// ./app/sagas/project.js
// module id = 636
// module chunks = 1